export default "__VITE_ASSET__30996f67__"